import React, { useState } from 'react';
import { hrChangePassword, getHrEmail } from '../api/auth';

// First-login gate: HR signs in with the temporary password we emailed and must
// set a new one before reaching the dashboard. Also reused from the profile menu
// for a voluntary change (forced=false shows a Cancel button).
export default function HRChangePassword({ forced = true, onDone, onCancel }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword.length < 8) {
      setError('New password must be at least 8 characters.');
      return;
    }
    if (newPassword !== confirm) {
      setError('New password and confirmation do not match.');
      return;
    }
    setLoading(true);
    try {
      await hrChangePassword(currentPassword, newPassword);
      onDone && onDone();
    } catch (err) {
      setError(err.message || 'Could not change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={submit}>
        <div className="login-brand">
          <h1>Set a new password</h1>
          <span>{getHrEmail()}</span>
        </div>

        {forced && (
          <div className="login-disabled">
            You signed in with a temporary password. Please set a new password to
            continue.
          </div>
        )}

        <label className="login-label">
          {forced ? 'Temporary password' : 'Current password'}
        </label>
        <input
          className="login-input"
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          autoComplete="current-password"
        />

        <label className="login-label">New password</label>
        <input
          className="login-input"
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          autoComplete="new-password"
        />

        <label className="login-label">Confirm new password</label>
        <input
          className="login-input"
          type="password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          autoComplete="new-password"
        />

        {error && <div className="login-error">{error}</div>}

        <button
          className="login-btn"
          type="submit"
          disabled={loading || !currentPassword || !newPassword || !confirm}
        >
          {loading ? 'Saving…' : 'Save password'}
        </button>

        {!forced && (
          <button
            type="button"
            className="login-btn login-btn-secondary"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </button>
        )}
      </form>
    </div>
  );
}
